import { computable, iterable, mix, observable, patch } from "@chorda/core";
import { Coerced } from "../../utils";
import './Carousel.scss';
export const Carousel = (props) => {
    return mix({
        css: 'carousel',
        templates: {
            slides: {
                css: 'carousel__slides',
                styles: {
                    height: 400
                },
                defaultItem: {
                    css: 'carousel__slide',
                    templates: {
                        content: Coerced({
                            reactions: {
                                slide: (v) => v && {
                                    styles: {
                                        backgroundImage: `url(${v.url})`
                                    },
                                    classes: {
                                        'hidden': v.hidden //.valueOf()
                                    },
                                    dom: {
                                        key: v.url //.valueOf()
                                    }
                                }
                            }
                        }),
                    }
                },
                reactions: {
                    __it: (v) => patch({ items: v })
                }
            },
            indicators: {
                tag: 'ul',
                css: 'carousel__indicators',
                defaultItem: Coerced({
                    tag: 'li',
                    reactions: {
                        slide: (v) => v && {
                            classes: {
                                'active': !v.hidden //.valueOf()
                            }
                        }
                    },
                    events: {
                        $dom: {
                            click: (e, { current, slide }) => {
                                current.$value = slide.id;
                                e.stopPropagation();
                            }
                        }
                    }
                }),
                reactions: {
                    __it: (v) => patch({ items: v })
                }
            },
            title: {
                css: 'carousel__title'
            }
        }
    }, props === null || props === void 0 ? void 0 : props.as, props && {
        css: props.css,
        templates: {
            slides: {
                defaultItem: props.image
            },
            title: props.title
        },
        defaults: {
            images: () => observable([]),
            current: () => observable(props.current || 0),
            //            slides: () => observable([]),
        },
        injections: {
            images: props.images$,
            slides: ({ images, current }) => computable(() => {
                return images.map((img, i) => {
                    return { id: i, url: img, hidden: i != current };
                });
            }),
            __it: (scope) => iterable(scope.slides, 'slide')
        },
        joints: {
            init: ({ current, images }) => {
                images.$subscribe((next) => {
                    if (next.length) {
                        current.$value = Math.min(current, next.length - 1);
                    }
                });
            }
            // current: {
            //     init: (current, {slides, images}) => {
            //         images.$subscribe((next) => {
            //             if (next.length) {
            //                 current.$value = Math.min(current, next.length-1)
            //             }
            //         })
            //     }
            // }
        },
        events: {
            $dom: {
                click: (e, { current, slides }) => {
                    console.log('slides', slides);
                    if (current.$value >= slides.length - 1) {
                        current.$value = 0;
                    }
                    else {
                        current.$value = current + 1;
                        console.log('current', current.$value);
                    }
                }
            }
        }
    });
};
